import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LandingTitle } from 'components/landing/ui/LandingTitle';
import { Props } from 'pages/bestofeurope/types';

import desktopAvif from './assets/desktop.avif';
import desktop from './assets/desktop.jpg';
import mobileAvif from './assets/mobile.avif';
import mobile from './assets/mobile.jpg';

const Root = styled.section`
  background-image: url(${mobile}});
  background-image: image-set(
    url(${mobileAvif}) type('image/avif'),
    url(${mobile})
  );
  background-size: cover;
  background-position: center;
  padding: calc(10 * var(--unit)) 0 150vw;
  @media ${tabletAndAbove} {
    background-image: url(${desktop}});
    background-image: image-set(
      url(${desktopAvif}) type('image/avif'),
      url(${desktop})
    );
    padding-bottom: 45vw;
  }
`;
const Header = styled(Vertical)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  @media ${tabletAndAbove} {
    position: unset;
    transform: unset;
  }
`;

export const Pick = ({ signUp }: Props) => {
  return (
    <Root>
      <Header center gap={3}>
        <LandingTitle>
          <FormattedMessage
            id="BestOfEurope.Pick.title"
            defaultMessage="Think you know ball?"
          />
        </LandingTitle>
        <Button size="large" color="secondary" onClick={signUp}>
          <FormattedMessage
            id="BestOfEurope.Pick.cta"
            defaultMessage="Yes, let's play!"
          />
        </Button>
      </Header>
    </Root>
  );
};
